import gql from 'graphql-tag';
export var AlertCertaintyType;
(function (AlertCertaintyType) {
    AlertCertaintyType["Likely"] = "Likely";
    AlertCertaintyType["Observed"] = "Observed";
    AlertCertaintyType["Possible"] = "Possible";
    AlertCertaintyType["Unknown"] = "Unknown";
    AlertCertaintyType["Unlikely"] = "Unlikely";
})(AlertCertaintyType || (AlertCertaintyType = {}));
export var AlertSeverityType;
(function (AlertSeverityType) {
    AlertSeverityType["Extreme"] = "Extreme";
    AlertSeverityType["Minor"] = "Minor";
    AlertSeverityType["Moderate"] = "Moderate";
    AlertSeverityType["Severe"] = "Severe";
    AlertSeverityType["Unknown"] = "Unknown";
})(AlertSeverityType || (AlertSeverityType = {}));
export var AlertStatusType;
(function (AlertStatusType) {
    AlertStatusType["Actual"] = "Actual";
    AlertStatusType["Draft"] = "Draft";
    AlertStatusType["Exercise"] = "Exercise";
    AlertStatusType["System"] = "System";
    AlertStatusType["Test"] = "Test";
    AlertStatusType["Unknown"] = "Unknown";
})(AlertStatusType || (AlertStatusType = {}));
export var AlertType;
(function (AlertType) {
    AlertType["Ack"] = "Ack";
    AlertType["Alert"] = "Alert";
    AlertType["Cancel"] = "Cancel";
    AlertType["Error"] = "Error";
    AlertType["Unknown"] = "Unknown";
    AlertType["Update"] = "Update";
})(AlertType || (AlertType = {}));
export var AlertUrgencyType;
(function (AlertUrgencyType) {
    AlertUrgencyType["Expected"] = "Expected";
    AlertUrgencyType["Future"] = "Future";
    AlertUrgencyType["Immediate"] = "Immediate";
    AlertUrgencyType["Past"] = "Past";
    AlertUrgencyType["Unknown"] = "Unknown";
})(AlertUrgencyType || (AlertUrgencyType = {}));
export var AudioStreamMediaType;
(function (AudioStreamMediaType) {
    AudioStreamMediaType["Aac"] = "AAC";
    AudioStreamMediaType["AacRaw"] = "AACRaw";
    AudioStreamMediaType["Abacast"] = "Abacast";
    AudioStreamMediaType["Flash"] = "Flash";
    AudioStreamMediaType["Hls"] = "HLS";
    AudioStreamMediaType["Html"] = "HTML";
    AudioStreamMediaType["Live365"] = "Live365";
    AudioStreamMediaType["Mp3"] = "MP3";
    AudioStreamMediaType["Mp3Raw"] = "MP3Raw";
    AudioStreamMediaType["None"] = "None";
    AudioStreamMediaType["Ogg"] = "OGG";
    AudioStreamMediaType["QuickTime"] = "QuickTime";
    AudioStreamMediaType["Real"] = "Real";
    AudioStreamMediaType["WmPro"] = "WMPro";
    AudioStreamMediaType["WmVideo"] = "WMVideo";
    AudioStreamMediaType["WmVoice"] = "WMVoice";
    AudioStreamMediaType["Windows"] = "Windows";
})(AudioStreamMediaType || (AudioStreamMediaType = {}));
export var AudioStreamRejectReason;
(function (AudioStreamRejectReason) {
    AudioStreamRejectReason["Bandwidth"] = "Bandwidth";
    AudioStreamRejectReason["Device"] = "Device";
    AudioStreamRejectReason["Disabled"] = "Disabled";
    AudioStreamRejectReason["DisabledRedirect"] = "DisabledRedirect";
    AudioStreamRejectReason["Live"] = "Live";
    AudioStreamRejectReason["Location"] = "Location";
    AudioStreamRejectReason["MediaType"] = "MediaType";
    AudioStreamRejectReason["NoStream"] = "NoStream";
    AudioStreamRejectReason["None"] = "None";
    AudioStreamRejectReason["Partner"] = "Partner";
    AudioStreamRejectReason["PlaylistSupport"] = "PlaylistSupport";
    AudioStreamRejectReason["RadioService"] = "RadioService";
    AudioStreamRejectReason["Region"] = "Region";
    AudioStreamRejectReason["Reliability"] = "Reliability";
    AudioStreamRejectReason["SubscriptionRequired"] = "SubscriptionRequired";
    AudioStreamRejectReason["TransferProtocol"] = "TransferProtocol";
})(AudioStreamRejectReason || (AudioStreamRejectReason = {}));
export var AudioStreamSortStrategy;
(function (AudioStreamSortStrategy) {
    AudioStreamSortStrategy["Mp3"] = "MP3";
    AudioStreamSortStrategy["PreferenceRaw"] = "PREFERENCE_RAW";
    AudioStreamSortStrategy["Quality"] = "QUALITY";
})(AudioStreamSortStrategy || (AudioStreamSortStrategy = {}));
export var DiscordActivityMode;
(function (DiscordActivityMode) {
    DiscordActivityMode["Hosted"] = "HOSTED";
    DiscordActivityMode["Shared"] = "SHARED";
})(DiscordActivityMode || (DiscordActivityMode = {}));
export var DiscordActivityPlaySpeed;
(function (DiscordActivityPlaySpeed) {
    DiscordActivityPlaySpeed["One"] = "ONE";
    DiscordActivityPlaySpeed["OnePointFive"] = "ONE_POINT_FIVE";
    DiscordActivityPlaySpeed["OnePointTwo"] = "ONE_POINT_TWO";
    DiscordActivityPlaySpeed["Pause"] = "PAUSE";
    DiscordActivityPlaySpeed["PointEight"] = "POINT_EIGHT";
    DiscordActivityPlaySpeed["PointFive"] = "POINT_FIVE";
    DiscordActivityPlaySpeed["Three"] = "THREE";
    DiscordActivityPlaySpeed["Two"] = "TWO";
})(DiscordActivityPlaySpeed || (DiscordActivityPlaySpeed = {}));
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["Kilometers"] = "KILOMETERS";
    DistanceUnit["Miles"] = "MILES";
    DistanceUnit["Unspecified"] = "UNSPECIFIED";
})(DistanceUnit || (DistanceUnit = {}));
export var EpisodeSort;
(function (EpisodeSort) {
    EpisodeSort["OldestFirst"] = "OLDEST_FIRST";
    EpisodeSort["RecentsFirst"] = "RECENTS_FIRST";
})(EpisodeSort || (EpisodeSort = {}));
export var GalleryLayout;
(function (GalleryLayout) {
    GalleryLayout["DescriptionTile"] = "DESCRIPTION_TILE";
    GalleryLayout["LargeTile"] = "LARGE_TILE";
    GalleryLayout["MiniTile"] = "MINI_TILE";
})(GalleryLayout || (GalleryLayout = {}));
export var GridLayout;
(function (GridLayout) {
    GridLayout["LargeTile"] = "LARGE_TILE";
})(GridLayout || (GridLayout = {}));
export var MusicContentType;
(function (MusicContentType) {
    MusicContentType["Artist"] = "ARTIST";
    MusicContentType["Song"] = "SONG";
    MusicContentType["Unknown"] = "UNKNOWN";
})(MusicContentType || (MusicContentType = {}));
export var SearchContentType;
(function (SearchContentType) {
    SearchContentType["Audiobook"] = "AUDIOBOOK";
    SearchContentType["Category"] = "CATEGORY";
    SearchContentType["Episode"] = "EPISODE";
    SearchContentType["Event"] = "EVENT";
    SearchContentType["Game"] = "GAME";
    SearchContentType["Podcast"] = "PODCAST";
    SearchContentType["Program"] = "PROGRAM";
    SearchContentType["Show"] = "SHOW";
    SearchContentType["Station"] = "STATION";
    SearchContentType["Unknown"] = "UNKNOWN";
})(SearchContentType || (SearchContentType = {}));
export var SystemMessageCode;
(function (SystemMessageCode) {
    SystemMessageCode["ServerShutdown"] = "SERVER_SHUTDOWN";
})(SystemMessageCode || (SystemMessageCode = {}));
export const AddUserConsentDocument = gql `
    mutation addUserConsent($consent: ConsentInput) {
  addConsent(consent: $consent) {
    id
  }
}
    `;
export const DiscordActivityLeaveDocument = gql `
    mutation discordActivityLeave($request: DiscordActivityLeaveRequest!) {
  DiscordActivityLeave(request: $request) {
    result
    message
  }
}
    `;
export const DiscordActivitySendDjRequestDocument = gql `
    mutation discordActivitySendDjRequest($request: DiscordActivityAddDjRequestRequest!) {
  DiscordActivitySendDjRequest(request: $request) {
    result
    message
  }
}
    `;
export const DiscordActivitySetCurrentListeningDocument = gql `
    mutation discordActivitySetCurrentListening($request: DiscordActivitySetCurrentListeningRequest!) {
  DiscordActivitySetCurrentListening(request: $request) {
    result
    message
  }
}
    `;
export const DiscordActivitySetHostDocument = gql `
    mutation discordActivitySetHost($request: DiscordActivitySetHostRequest!) {
  DiscordActivitySetHost(request: $request) {
    result
    message
  }
}
    `;
export const DiscordActivitySetModeDocument = gql `
    mutation discordActivitySetMode($request: DiscordActivitySetModeRequest!) {
  DiscordActivitySetMode(request: $request) {
    result
    message
  }
}
    `;
export const GetUserDocument = gql `
    query getUser($device: Device) {
  user(device: $device) {
    userId
    userName
    firstName
    lastName
    isFollowingListPublic
    isRegistered
    imageUrl
    bannerImageUrl
    subscriptions {
      edges {
        node {
          status
          expiresOn
          providerId
          providerName
          key
        }
      }
    }
    email
  }
}
    `;
export const GetUserConsentsDocument = gql `
    query getUserConsents($userId: String) {
  getUserConsents(userId: $userId) {
    simpleConsents {
      id
      userEmail
    }
  }
}
    `;
export const DiscordActivitySubscribeDocument = gql `
    subscription discordActivitySubscribe($request: DiscordActivitySubscribeRequest!) {
  DiscordActivitySubscribe(request: $request) {
    ... on DiscordActivity {
      activityId
      listening {
        timestamp
        discordUserId
        guideId
        streamOffsetMs
        playSpeed
      }
      activityMode
      hostId
      geolocations
      participantGeolocations {
        geolocations {
          isoCode
          memberCount
        }
      }
    }
    ... on SystemMessage {
      code
    }
    ... on DiscordActivityJoinResponse {
      sessionId
    }
  }
}
    `;
export function getSdk(requester) {
    return {
        addUserConsent(variables, options) {
            return requester(AddUserConsentDocument, variables, options);
        },
        discordActivityLeave(variables, options) {
            return requester(DiscordActivityLeaveDocument, variables, options);
        },
        discordActivitySendDjRequest(variables, options) {
            return requester(DiscordActivitySendDjRequestDocument, variables, options);
        },
        discordActivitySetCurrentListening(variables, options) {
            return requester(DiscordActivitySetCurrentListeningDocument, variables, options);
        },
        discordActivitySetHost(variables, options) {
            return requester(DiscordActivitySetHostDocument, variables, options);
        },
        discordActivitySetMode(variables, options) {
            return requester(DiscordActivitySetModeDocument, variables, options);
        },
        getUser(variables, options) {
            return requester(GetUserDocument, variables, options);
        },
        getUserConsents(variables, options) {
            return requester(GetUserConsentsDocument, variables, options);
        },
        discordActivitySubscribe(variables, options) {
            return requester(DiscordActivitySubscribeDocument, variables, options);
        }
    };
}
